import styled from 'styled-components';

export const ContactItemStyle = styled.li`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 400px;
    padding: 10px;
    border: 1px solid #31d37a;
`;